import script from "./ActiveGamesSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveGamesSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ActiveGamesSidebar.vue?vue&type=style&index=0&id=33c53dcc&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c53dcc"]])

export default __exports__